<template>
  <div class="outer-wrapper">
    <div class="inner-page animate__animated animate__slideInRight">
      <div class="container-fluid">
        <template v-if="leadHistory && leadHistory.length">
          <div class="card card-details">
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <span class="d-block title">{{ leadName}}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="card card-details property-card" v-for="(history, hIndex) in leadHistory"
            :key="history.id || hIndex">
            <div class="card-body">

              <!-- Header -->
              <div class="row align-items-start mb-3">
                <div class="col-12">
                  <div class="project-title-wrap" v-if="history?.project_name">
                    <span class="building-icon">
                      <img src="@/assets/project-icon.svg" alt="project-icon">
                    </span>
                    <span class="title mb-0">{{ history.project_name }}</span>
                  </div>
                </div>
              </div>

              <!-- Details -->
              <div class="details-list">
                <div v-if="history?.created_at" class="detail-block">
                  <span class="detail-label">Enquired Date</span>
                  <span class="detail-value">{{ formatDateTime(history.created_at) }}</span>
                </div>

                <div v-if="history?.assigned_to" class="detail-block">
                  <span class="detail-label">Assigned To</span>
                  <span class="detail-value">{{ history.assigned_to }}</span>
                </div>

                <div class="detail-block">
                  <div class="detail-block">
                    <span class="detail-label">Executives Comments</span>
                    <span class="detail-value">
                      {{
                        isExpanded('comment-' + hIndex)
                          ? (history.comment || '-')
                          : getShortText(history.comment)
                      }}

                      <span v-if="history.comment && history.comment.length > commentLimit" class="show-more-btn"
                        @click="toggleExpand('comment-' + hIndex)">
                        {{ isExpanded('comment-' + hIndex) ? 'Show Less' : 'Show More' }}
                      </span>
                    </span>
                  </div>
                </div>

                <div v-if="history?.lead_no" class="detail-block">
                  <span class="detail-label">Lead No</span>
                  <span class="detail-value">{{ history.lead_no }}</span>
                </div>

                <div class="detail-block">
                  <span class="detail-label">Visits</span>
                  <span class="detail-value">{{ history?.visits?.length || 0 }}</span>
                </div>

                <div class="detail-block mb-3">
                  <span class="detail-label">is Booked?</span>
                  <span class="detail-value">{{ history?.booking_done ? 'Yes' : 'No' }}</span>
                </div>
              </div>

              <!-- Tabs -->
              <template v-if="history?.visits?.length">
                <div class="custom-tabs">
                  <button v-for="(visit, vIndex) in history.visits" :key="vIndex" class="tab-btn"
                    :class="{ active: activeTabs[hIndex] === vIndex }" @click="setActiveTab(hIndex, vIndex)">
                    Visit {{ vIndex + 1 }}
                  </button>
                </div>

                <!-- Tab Content -->
                <div class="tab-content-box">
                  <div class="detail-block">
                    <span class="detail-label">Visit Date</span>
                    <span class="detail-value">{{ getVisit(history, hIndex).visit_date }}</span>
                  </div>

                  <div class="detail-block">
                    <span class="detail-label">Field Executive</span>
                    <span class="detail-value">
                      {{ getVisit(history, hIndex).field_executive || '-' }}
                    </span>
                  </div>

                  <div class="detail-block">
                    <span class="detail-label">Cross Pitch Project</span>
                    <span class="detail-value">
                      {{ getVisit(history, hIndex).cross_pitch_project || '-' }}
                    </span>
                  </div>

                  <!-- Comment -->
                  <div class="detail-block mb-0">
                    <span class="detail-label">Comment</span>
                    <span class="detail-value">
                      {{
                        isExpanded('visit-' + hIndex + '-' + activeTabs[hIndex])
                          ? (getVisit(history, hIndex).comment || '-')
                          : getShortText(getVisit(history, hIndex).comment)
                      }}

                      <span
                        v-if="getVisit(history, hIndex).comment && getVisit(history, hIndex).comment.length > commentLimit"
                        class="show-more-btn" @click="toggleExpand('visit-' + hIndex + '-' + activeTabs[hIndex])">
                        {{ isExpanded('visit-' + hIndex + '-' + activeTabs[hIndex]) ? 'Show Less' : 'Show More' }}
                      </span>
                    </span>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
        <div v-else-if="!loading" class="align-items-center d-flex justify-content-center mt-4 text-black-50">No Data Available</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FileHistory",
  data() {
    return {
      leadHistory: [],
      activeTabs: {},
      expandedComments: {},
      commentLimit: 5,
      loading: true
    };
  },
  created() {
    this.fetchLeadHistory();
  },
  methods: {
    fetchLeadHistory() {
      const uuid = this.$route.params.id;
      if (!uuid) return;
      this.loading = true;
      this.$axios.get(`leads/${uuid}/crm_lead_history`)
        .then(({ data }) => {
          this.leadHistory = data?.lead_histories || [];
          this.leadName = data?.lead?.lead_name || '';
          this.leadHistory.forEach((_, i) => {
            this.$set(this.activeTabs, i, 0);
          });
        })
        .catch(err => console.error('error', err))
        .finally(() => {
          this.loading = false;
        });
    },

    setActiveTab(hIndex, vIndex) {
      this.$set(this.activeTabs, hIndex, vIndex);
    },

    getVisit(history, hIndex) {
      const idx = this.activeTabs[hIndex] ?? 0;
      return history?.visits?.[idx] || {};
    },

    isExpanded(index) {
      return !!this.expandedComments[index];
    },

    toggleExpand(index) {
      this.$set(this.expandedComments, index, !this.expandedComments[index]);
    },

    getShortText(text) {
      if (!text) return '-';
      return text.length > this.commentLimit
        ? text.slice(0, this.commentLimit) + '...'
        : text;
    },
    formatDateTime(date) {
      if (!date) return ''
      return this.$moment(date).format('DD MMM YYYY, hh:mm:ss A')
    }
  }
};
</script>


<style scoped>
.project-header {
  display: inline-flex;
  gap: 4px;
}

.property-card {
  width: 100%;
  /* max-width: 290px; */
  background: #f6f6f6;
  border: none;
  border-radius: 10px;
  box-shadow: none;
  padding: 0;
}

.property-card .card-body {
  padding: 14px 12px 12px;
}

.project-title-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
}

.building-icon {
  font-size: 14px;
  color: #8c8c8c;
  line-height: 1;
  margin-top: 1px;
}

.title {
  display: block;
  font-size: 20px;
  font-weight: 500;
  color: #000000;
  line-height: 1.2;
}

.details-list {
  margin-bottom: 8px;
}

.detail-block {
  margin-bottom: 16px;
}

.detail-label {
  display: block;
  font-size: 14px;
  color: #000000;
  font-weight: 500;
  margin-bottom: 6px;
  line-height: 1.2;
  opacity: 0.5;
}

.detail-value {
  display: block;
  font-size: 16px;
  color: #000000;
  font-weight: 500;
  line-height: 1.3;
  word-break: break-word;
}

.custom-tabs {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  border-bottom: 1px solid #d8d8d8;
  margin: 10px -12px 0;
  padding: 0 0 0 10px;
  scroll-behavior: smooth;
}

.custom-tabs::-webkit-scrollbar {
  display: none;
}

.custom-tabs {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.tab-btn {
  flex: 0 0 auto;
  min-width: 78px;
  padding: 12px 10px 10px;
  font-size: 13px;
  font-weight: 500;
  color: #7b7b7b;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  outline: none;
  cursor: pointer;
  transition: 0.2s ease;
}

.tab-btn.active {
  color: #f28c28;
  border-bottom: 2px solid #f28c28;
  background: #f7f7f7;
}

.tab-content-box {
  background: #efefef;
  padding-top: 12px;
}

.comment-text {
  max-width: 220px;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.row {
  display: flex;
  flex-wrap: wrap;
}

.col-8 {
  width: 66.666667%;
}

.align-items-start {
  align-items: flex-start;
}

.show-more-btn {
  display: inline-block;
  margin-top: 4px;
  font-size: 16px;
  font-weight: 600;
  color: #f59b1a;
  cursor: pointer;
  user-select: none;
}
</style>